import { OrderRow } from '../types'

export type OrdersTab = 'order_queue' | 'order_history' | 'order_issues'

export type TimeKind = 'original' | 'planned' | 'actual'

type TimeField = keyof Pick<
  OrderRow,
  | 'original_planned_start_time'
  | 'planned_start_time'
  | 'start_time'
  | 'original_planned_end_time'
  | 'planned_end_time'
  | 'end_time'
>

export const TIME_COLUMN_KEYS = ['start_time', 'end_time'] as const

export type TimeColumnKey = (typeof TIME_COLUMN_KEYS)[number]

export const isTimeColumn = (key: string): key is TimeColumnKey =>
  (TIME_COLUMN_KEYS as readonly string[]).includes(key)

const TIME_FIELDS: Record<TimeColumnKey, Record<TimeKind, TimeField>> = {
  start_time: {
    original: 'original_planned_start_time',
    planned: 'planned_start_time',
    actual: 'start_time'
  },
  end_time: {
    original: 'original_planned_end_time',
    planned: 'planned_end_time',
    actual: 'end_time'
  }
}

// Once a meal is done the planned times have been dragged onto the actual ones,
// so past meals only compare the original estimate with what really happened
const HISTORY_TIME_KINDS: TimeKind[] = ['original', 'actual']

export const TIME_KINDS: Record<OrdersTab, TimeKind[]> = {
  order_queue: ['original', 'planned', 'actual'],
  order_history: HISTORY_TIME_KINDS,
  order_issues: HISTORY_TIME_KINDS
}

const LAST_COLUMN_KEYS: Record<OrdersTab, string[]> = {
  order_queue: ['actions'],
  order_history: [],
  order_issues: []
}

export const timeValue = (
  row: OrderRow,
  column: TimeColumnKey,
  kind: TimeKind
): string | null => row[TIME_FIELDS[column][kind]] ?? null

export const columnKeys = (tab: OrdersTab): string[] => [
  'meal',
  'locker',
  'unit',
  'measured_meal_weight',
  'order_status',
  'order_received',
  ...TIME_COLUMN_KEYS,
  ...LAST_COLUMN_KEYS[tab]
]

export const columnCount = (tab: OrdersTab): number => columnKeys(tab).length
